export const ARTICLES = '/articles';
export const PROFILE = '/profile'